const styles = {
  dialog: {display: 'flex', justifyContent: 'center'},
  content: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
};

export default styles;
